import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './video.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
var Video = /** @class */ (function (_super) {
    tslib_1.__extends(Video, _super);
    function Video(element) {
        var _this = _super.call(this, element) || this;
        _this.playerRatioLarge = 854 / 480;
        _this.playerRatioSmall = 290 / 180;
        return _this;
    }
    Video.prototype.init = function () {
        this.banner = this.element.querySelector('.js-video-container');
        this.playerContainer = this.element.querySelector('.video__player-container');
        this.playerContent = this.element.querySelector('.video__player-content');
        this.player = this.playerContainer.querySelector('.ot-video-containingBlock');
        this.video = this.element.querySelector('video');
        this.closeButton = this.element.querySelector('.js-close-video');
        this.playButton = this.element.querySelector('.js-open-video');
        if (this.element.classList.contains('js-no-image')) {
            this.showVideoNoImage(this.playButton);
        }
    };
    Video.prototype.bindEvents = function () {
        window.addEventListener('resize', this.onResize.bind(this));
        window.addEventListener('orientationchange', this.onResize.bind(this));
        setTimeout(this.onResize.bind(this), 200);
        setTimeout(this.checkVideoPlayer.bind(this), 200);
        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.hideVideo.bind(this));
        }
        if (this.playButton) {
            this.playButton.addEventListener('click', this.showVideo.bind(this));
        }
    };
    Video.prototype.showVideo = function (event) {
        event.preventDefault;
        if (event.currentTarget.hasAttribute('data-youtube-id')) {
            this.isExternal = true;
            var videoExternal = event.currentTarget;
            this.element.classList.add('video--playing');
            var getVideo = videoExternal.getAttribute('data-youtube-id');
            this.createIframePlayer(getVideo);
            this.analyticsService.dtmVideoTrackerAutoSpot();
        }
        else if (event.currentTarget.hasAttribute('data-video-file')) {
            this.isExternal = true;
            var videoExternal = event.currentTarget;
            this.element.classList.add('video--playing');
            var getVideo = videoExternal.getAttribute('data-video-file');
            this.createHTML5Player(getVideo);
        }
        else {
            this.element.classList.add('video--playing');
            this.video.player.play();
        }
    };
    Video.prototype.hideVideo = function (event) {
        var removeIframe = this.playerContent.querySelector('iframe');
        if (removeIframe) {
            this.playerContent.removeChild(removeIframe);
        }
        event.preventDefault;
        this.element.classList.remove('video--playing');
        this.video.player.pause();
    };
    Video.prototype.onResize = function () {
        this.banner.style.opacity = '1';
        this.setVideoPlayerDimensions();
    };
    Video.prototype.checkVideoPlayer = function () {
        if (this.player === null) {
            setTimeout(this.checkVideoPlayer.bind(this), 200);
        }
        else {
            this.playerContainer.style.opacity = '1';
            this.playerContainer.style.visibility = 'visible';
            if (!this.element.classList.contains('js-no-image')) {
                this.playerContainer.style.display = 'none';
            }
        }
    };
    Video.prototype.setVideoPlayerDimensions = function () {
        if (!this.isExternal) {
            if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {
                this.banner.style.height = (this.banner.offsetWidth / this.playerRatioSmall) + "px";
                this.playerContainer.style.minHeight = this.banner.clientHeight + "px";
                this.playerContainer.style.height = 'auto';
                this.playerContent.style.height = 'auto';
            }
            else {
                this.banner.style.height = (this.banner.offsetWidth / this.playerRatioLarge) + "px";
                this.playerContainer.style.removeProperty('height');
                this.playerContent.style.removeProperty('height');
            }
        }
        else {
            if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {
                this.banner.style.height = (this.banner.offsetWidth / this.playerRatioSmall) + "px";
                this.playerContainer.style.minHeight = this.banner.clientHeight + "px";
            }
            else {
                this.banner.style.height = (this.banner.offsetWidth / this.playerRatioLarge) + "px";
            }
        }
    };
    Video.prototype.createIframePlayer = function (url) {
        this.playerContent.style.height = '100%';
        this.playerContainer.style.opacity = '1';
        this.playerContainer.style.visibility = 'visible';
        this.playerContainer.style.display = 'none';
        this.playerContainer.style.height = '100%';
        var externalUrl = 'https://www.youtube.com/embed/';
        externalUrl += url;
        externalUrl += '?rel=0&amp;showinfo=0&showinfo=0&enablejsapi=1';
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.setAttribute('allowfullscreen', 'true');
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    Video.prototype.createIframePlayerInit = function (url) {
        this.playerContent.style.height = '100%';
        this.playerContainer.style.opacity = '1';
        this.playerContainer.style.visibility = 'visible';
        this.playerContainer.style.height = '100%';
        var externalUrl = 'https://www.youtube.com/embed/';
        externalUrl += url;
        externalUrl += '?rel=0&amp;showinfo=0&enablejsapi=1';
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.setAttribute('allowfullscreen', 'true');
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    Video.prototype.createHTML5Player = function (url) {
        this.playerContent.style.height = '100%';
        this.playerContainer.style.opacity = '1';
        this.playerContainer.style.visibility = 'visible';
        this.playerContainer.style.display = 'none';
        this.playerContainer.style.height = '100%';
        var externalUrl = url;
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.setAttribute('allowfullscreen', 'true');
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    Video.prototype.createHTML5PlayerInit = function (url) {
        this.playerContent.style.height = '100%';
        this.playerContainer.style.opacity = '1';
        this.playerContainer.style.visibility = 'visible';
        this.playerContainer.style.height = '100%';
        var externalUrl = url;
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.setAttribute('allowfullscreen', 'true');
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    Video.prototype.showVideoNoImage = function (element) {
        this.playerContainer.classList.add('video--playing');
        if (element.hasAttribute('data-youtube-id')) {
            this.isExternal = true;
            var videoExternal = element;
            var getVideo = videoExternal.getAttribute('data-youtube-id');
            this.createIframePlayerInit(getVideo);
            this.analyticsService.dtmVideoTrackerAutoSpot();
        }
        else if (element.hasAttribute('data-video-file')) {
            this.isExternal = true;
            var videoExternal = element;
            var getVideo = videoExternal.getAttribute('data-video-file');
            this.createHTML5PlayerInit(getVideo);
        }
        else {
            // if(this.player) {
            // 	if(this.video){
            // 		if(this.video.player) {
            // 			this.video.player.play();
            // 			this.player.style.height = "100%";
            // 		}
            // 	}
            // }
        }
    };
    return Video;
}(Base));
export { Video };



//////////////////
// WEBPACK FOOTER
// ./components/video/video.component.ts
// module id = 554
// module chunks = 0